import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MetricDto } from 'src/app/services/models/metric.models';

@Component({
  selector: 'bhub-metric-field',
  templateUrl: './metric-field.component.html',
  styleUrls: ['./metric-field.component.scss'],
  standalone: true,
  imports: [CommonModule, MatIconModule, MatButtonModule]
})
export class MetricFieldComponent {
  @Input() metric!: MetricDto;
  @Input() x: number = 0;
  @Input() y: number = 0;
  @Input() zIndex: number = 1;
  @Input() index: number = 0;
  @Input() selectedFields: Set<string> = new Set();

  @Output() dragStart = new EventEmitter<{event: DragEvent, index: number}>();
  @Output() remove = new EventEmitter<MetricDto>();
  @Output() metricClick = new EventEmitter<{metricIndex: number, metricName: string}>();

  onDragStart(event: DragEvent) {
    this.dragStart.emit({ event, index: this.index });
  }

  onRemove() {
    this.remove.emit(this.metric);
  }

  onMetricClick() {
    this.metricClick.emit({ metricIndex: this.index, metricName: this.metric.metricName });
  }

  isMetricSelected(): boolean {
    const fieldKey = `metric_${this.index}_${this.metric.metricName}`;
    return this.selectedFields.has(fieldKey);
  }
}
